// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect } from 'react';
import styled from 'styled-components';
import TopHeader from '../common/topHeader';
import ScrollButton from './top/backToTop/ScrollButton';
import { useLocation, Link } from 'react-router-dom';

const QuestionItem = styled.div`
  margin-bottom: 50px;
  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

const Header = styled.div`
  @media screen and (max-width: 768px) {
    .top-header {
      font-size: 14px !important;
    }
  }
`;
const Title = styled.div`
  font-size: 30px;
  letter-spacing: 0.1em;
  line-height: 40px;
  color: #464646;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
  }
`;

const Question = styled.div`
  font-size: 20px;
  letter-spacing: 0.1em;
  line-height: 24px;
  color: #000000;
  font-weight: bold;
  margin-top: 50px;

  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 20px;
    margin-top: 20px;
  }
`;

const Border = styled.div`
  border: 1px solid #707070;
  width: 100%;
  margin: 20px 0;
  opacity: 0.4;
  @media screen and (max-width: 768px) {
    margin: 10px 0;
  }
`;
const Answer = styled.div`
  font-size: 16px;
  letter-spacing: 0.1em;
  line-height: 24px;
  margin-bottom: 30px;
  color: #000000;

  @media screen and (max-width: 768px) {
    font-size: 8px;
    line-height: 20px;
    margin-bottom: 15px;
  }
`;
const Browser = styled.div`
  margin-top: 30px;
  @media screen and (max-width: 768px) {
    margin-top: 15px;
  }
`;
export default function Questions() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: 'auto' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Header>
        <TopHeader title="くじロードONLINE　ヘルプページ（よくある質問）" />
      </Header>
      <div className="main-content form-static">
        <QuestionItem>
          <Title>【くじロードONLINEについて】</Title>
          <Question>Q1 くじロードONLINEとは？</Question>
          <Border />
          <Answer>
            かんたん・手軽にワクワク体験。当たって嬉しい、ハズレなしのオンラインくじです。
            <br />
            購入した商品は後日、自宅で受け取ることができます。遊び方については、「
            <Link to="/guide">くじロードONLINEご利用ガイド</Link>
            」もご参照ください。
          </Answer>

          <Question>
            Q2 スマートフォン（iOS・Android）、パソコン、どちらでも購入できますか？
          </Question>
          <Border />
          <Answer>
            スマートフォン（iOS・Android）、パソコンで購入可能です。フィーチャーフォンには対応しておりませんのでご了承ください。
          </Answer>

          <Question>Q3 ご利用環境について</Question>
          <Border />
          <Answer>
            くじロードONLINEを快適にご利用いただくために下記ブラウザを推奨いたします。
            <br />
            下記の動作確認環境以外では、正しく動作しない場合がございます。
            <br />
            ■PC
            <br />
            Microsoft Edge 最新版
            <br />
            Mozilla Firefox 最新版
            <br />
            Google Chrome 最新版
            <br />
            Safari 最新版
            <Browser>
              ■モバイル
              <br />
              iOS 11以降のChrome/Safari
              <br />
              Android 6以降のChrome
              <br />
            </Browser>
          </Answer>

          <Question>Q4 会員登録はどうすればよいですか？</Question>
          <Border />
          <Answer>
            サイト上部に表示されている「会員登録」から新規登録が行えます。
            <br />
            会員登録とログインの後、各販売ページよりご購入いただけます。
            <br />
            詳しくは下記ガイドページもご確認ください。
            <br />
            <Link to="/guide">「くじロードONLINEご利用ガイド」へ</Link>
            <br />
          </Answer>

          <Question>
            <div id="Q5">Q5 破棄機能とは？</div>
          </Question>
          <Border />
          <Answer>
            当選した商品を破棄することにより、受け取り数を調整する機能です。破棄する場合、くじ購入後にMYコレクションより設定することができます。不要な商品を破棄することで、新たにくじを引けるポイントに変換することも可能です。
            <br />
            ※破棄した商品の代金は返金されません。
            <br />
            ※お客様が破棄できる期限は、くじ販売終了翌日の23:59までとなります。
            <br />
            ※破棄により付与されたポイントの有効期限は、最後のポイント付与日から365日間です。
            <br />
            ※すべての商品を破棄された場合、商品のお届けはされませんが「配送手数料」としてシステム利用手数料を頂戴しております。こちらはご返金されませんので、あらかじめご了承ください。
            <br />
            ※破棄機能がついていないくじや、破棄してもポイントの付与や使用ができないくじがあります。詳細は各くじの説明をご確認ください。
          </Answer>

          <Question>
            <div id="Q6">Q6 ポイントについて</div>
          </Question>
          <Border />
          <Answer>
            くじロードONLINEでご利用いただけるポイントサービスです。
            <br />
            ポイントを利用してくじを引くことが可能です。
            <br />
            ポイントの保有期間は、付与から365日間となります。
            <br />
            ポイント保有状況は、マイページよりご確認いただけます。
            <br />
            ポイントは1ポイント1円として、どのタイトルのくじでもご利用可能です。
            <br />
            ※破棄機能がついていないくじや、破棄してもポイントの付与や使用ができないくじがあります。詳細は各くじの説明をご確認ください。
          </Answer>

          <Question>Q7 当選商品の選択機能に関して</Question>
          <Border />
          <Answer>
            くじロードONLINEでは当選した商品の中から、個別の商品を選択できる場合がございます。選択できる場合は、商品の説明に「当選商品の選択が可能」などと付記されています。
            <br />
            <br />
            （商品選択例）
            <br />
            <br />
            A賞 アクリルスタンド（全3種）
            <br />
            <br />
            A賞-1 白くま アクスタ
            <br />
            A賞-2 黒くま アクスタ
            <br />
            A賞-3 茶くま アクスタ
            <br />
            <br />
            もし上記のA賞が当選したら、選択画面にてA-1〜3までのいずれかひとつの商品を選択することができます。
            <br />
            <br />
            ※理由のいかんを問わず、ブラウザを閉じる、または不正終了等により、お客様が正しく商品選択を行わなかった場合、翌日以降にサポートよりメールが送信されますので、メール文面に記載されている方法で、選択する商品を必ずご連絡ください。
            <br />
            ※ただし、商品選択のサポート受付は、販売終了後24時間後までとなります。それまでに商品選択がされない場合、当社のシステムによる自動抽選により商品選択が行われ、商品が確定されます。お客様が希望する商品でない等の自動抽選による商品選択を理由とするキャンセル、返品及び交換等はできません。
          </Answer>
        </QuestionItem>

        <QuestionItem>
          <Title>【購入について】</Title>
          <Question>Q1 年齢制限はありますか？</Question>
          <Border />
          <Answer>18歳未満の方は、ご購入頂く事はできません。</Answer>

          <Question>Q2 購入の受付メールは届きますか？</Question>
          <Border />
          <Answer>購入時点で、メールにて決済完了メールをお届けします。</Answer>

          <Question>Q3 注文内容・当選結果はどこで確認できますか？</Question>
          <Border />
          <Answer>
            「メニュー」の「購入履歴」をご確認ください。詳細を確認することができます。
          </Answer>

          <Question>Q4 購入後のキャンセルはできますか？</Question>
          <Border />
          <Answer>
            購入後のキャンセルは不可となっており、くじ演出の表示有無に関わらず当選は確定します。理由のいかんを問わず、ブラウザを閉じる、または不正終了等により、くじ演出が表示されなかったとしても、原則として、返金には応じません。
          </Answer>

          <Question>Q5 利用できる支払い方法は？</Question>
          <Border />
          <Answer>
            ・クレジットカード（VISA、MASTER、JCB、AMEX、DINERS）
            <br />
            ・d払い
            <br />
            ・ソフトバンクまとめて支払い
            <br />
            ・楽天ペイ
            <br />
            ・メルペイネット
            <br />
          </Answer>

          <Question>Q6 購入後にクレジットカードを変更したい</Question>
          <Border />
          <Answer>
            購入後のクレジット情報の変更はできかねますので、正確な情報を入力ください。
            <br />
            ※なお、サービスの特性上、お客様都合でのキャンセル・返品・交換は承っておりません。
          </Answer>

          <Question>Q7 購入後に支払い方法を変更したい</Question>
          <Border />
          <Answer>購入後のお支払い方法の変更はできかねます。</Answer>

          <Question>Q8 入力したカード番号、暗証番号が違うと言われて支払認証できない</Question>
          <Border />
          <Answer>
            お支払い時の決済認証が得られなかった理由については、当社で確認することができません。詳細はご利用のカード会社、各キャリアへご確認をお願いいたします。
          </Answer>

          <Question>Q9 領収書は発行してもらえますか？</Question>
          <Border />
          <Answer>
            領収書の発行はしておりません。クレジットカード会社等が発行するご利用明細書を領収書としてご利用ください。
          </Answer>
        </QuestionItem>

        <QuestionItem>
          <Title>【配送について】</Title>
          <Question>Q1 送料はいくらかかりますか？</Question>
          <Border />
          <Answer>
            送料は各商品ページをご確認ください。
            <br />
            ※注文個数が1回分の送料でお届けできる個数を超えた場合、以降、上限の個数ごとに送料が発生します。
            <br />
            【例】くじ20個まで1回分の送料でお届けの場合
            <br />
            ・購入数1-20個までは複数回のご注文でも1回分の送料でお届けします。
            <br />
            ・購入数21-40個までは複数回のご注文でも2回分の送料でお届けします。
            <br />
          </Answer>

          <Question>Q2 発送状況について知りたい</Question>
          <Border />
          <Answer>発送状況は、「メニュー」の「購入履歴」よりご確認いただけます。</Answer>

          <Question>Q3 購入後に送付先を変更できますか？</Question>
          <Border />
          <Answer>
            【購入後〜販売終了翌日の23:59まで】
            <br />
            購入済み後のお届け先変更はログイン後、「マイページ」の「購入履歴」から変更が可能です。
            <br />
            <br />
            【販売終了翌々日の0:00以降】
            <br />
            既に発送の準備が進んでいるため、当社側で個別に住所変更・差し替えを行うことができません。
            <br />
            誠に恐れ入りますが、商品発送後、「マイページ」より伝票番号をご確認いただき配送業者さまへ転送のご相談をお願いいたします。
          </Answer>

          <Question>Q4 海外対応はしていますか？ (Can this service be used outside Japan?)</Question>
          <Border />
          <Answer>
            当サービスは日本国内においてのみご利用可能となります。
            <br />
            We do not accept orders from outside of Japan. We can not send goods to outside of
            Japan.
          </Answer>

          <Question>Q5 配送はいつになりますか？</Question>
          <Border />
          <Answer>
            各商品の配送時期に関しましては、各商品ページのお届け目安をご確認ください。
            <br />
            ※受注生産品が多く含まれるため、ご注文から配送までにお時間を頂く場合がございます。予めご了承ください。
            <br />
            ※お届けする商品が複数の場合、商品によっては同日のお届けとならず時期が若干ずれる場合があります。予めご了承ください。
          </Answer>

          <Question>Q6 別々の注文番号の商品を同梱発送してもらうことはできますか？</Question>
          <Border />
          <Answer>
            誠に申し訳ございませんが、同梱希望は承っておりません。なお、別々の注文番号の場合でも、同梱発送させていただく場合がございます。
          </Answer>

          <Question>Q7 長期不在等の理由で商品が受け取れない場合は？</Question>
          <Border />
          <Answer>
            商品お届け時にご不在の場合は、配送業者が投函する「ご不在連絡票」に従い、商品のお受け取り手続きをお願いいたします。
            <br />
            発送完了後3日が経過しても初回配達がない場合は、住所不明の可能性がございますので、配送業者へご連絡ください。
          </Answer>

          <Question>Q8 保管期間は？</Question>
          <Border />
          <Answer>
            長期不在や住所不明で配送業者の保管期間内にお受け取りいただけなかった場合、商品は当社又は当社の委託業者に返送されます。
            <br />
            返送から2ヶ月が経過した時点でご注文はキャンセルとさせていただきますので、お早めにくじロードONLINEお問い合わせ窓口(support@kujiroad.net)まで再発送のご依頼をお願いいたします。
            <br />
            ※再発送にかかる往復送料等はお客様のご負担となります。
          </Answer>
        </QuestionItem>

        <QuestionItem>
          <Title>【キャンセル・交換・返品について】</Title>
          <Question>Q1 キャンセル・交換・返品はできますか？</Question>
          <Border />
          <Answer>
            【オンラインくじ】というサービスの特性上、ご注文完了後（ご注文に基づく「抽選結果」の表示による商品確定後）は、お客様都合によるキャンセル・返品・交換は承っておりません。詳細は、「特定商取引法に基づく表示」をご確認ください。
          </Answer>

          <Question>Q2 商品に不良があったので交換してほしい</Question>
          <Border />
          <Answer>
            お届けした商品に不具合、商品違い又は数量不足等があった場合には、商品到着後7日以内にくじロードONLINEお問い合わせ窓口(support@kujiroad.net
            )までご連絡ください。詳細は、「特定商取引法に基づく表示」をご確認ください。
          </Answer>
        </QuestionItem>

        <QuestionItem>
          <Title>【その他】</Title>
          <Question>Q1 退会について</Question>

          <Border />
          <Answer>
            「マイページ」下部にある「退会はこちら」よりお手続きをお願いいたします。
            <br />
            一度退会した、くじロードONLINEログイン用メールアドレスと同じメールアドレスで、くじロードONLINEの会員再登録は可能です。
            <br />
          </Answer>

          <Question>Q2 個人情報の取り扱いについて知りたい</Question>
          <Border />
          <Answer>
            お客様からいただいた個人情報の取扱いについては、当社の「
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                window.open('https://bushiroad.co.jp/privacy', '_blank', 'noopener,noreferrer');
              }}
            >
              プライバシーポリシー
            </Link>
            」をご確認ください。
          </Answer>

          <Question>Q3 その他のお問い合わせについて</Question>
          <Border />
          <Answer>
            上記にて解決しないお問い合わせに関しましては、くじロードONLINEお問い合わせ窓口(support@kujiroad.net)より24時間受け付けております。
            <br />
            ※お問い合わせへのご返答は、翌営業日以降に順次お返事させていただきます。
          </Answer>
        </QuestionItem>
      </div>
      <ScrollButton />
    </>
  );
}
